import axios from 'axios'
import { ALTERAR_SENHA_USUARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function trocarSenhaUsuario (email, codigo, senha) {
  const url = `${URL}/usuarios/public/trocar-senha`;
  return dispatch => axios.post(url,{ email, codigo, senha } , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ALTERAR_SENHA_USUARIO,
        payload: response
      })
  );
}
